import React, { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY, USER_KEY } from "@/lib/api";

const AuthCtx = createContext(null);

export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading
  const [token, setToken] = useState(localStorage.getItem(TOKEN_KEY));

  useEffect(() => {
    let alive = true;
    if (!token) { setUser(null); return; }
    api.get("/auth/me")
      .then((r) => { if (alive) setUser(r.data); })
      .catch(() => { if (alive) { setUser(null); localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(USER_KEY); } });
    return () => { alive = false; };
  }, [token]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    localStorage.setItem(USER_KEY, JSON.stringify(data.user));
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    setToken(null);
    setUser(null);
  };

  const hasRole = (...roles) => user && (user.role === "admin" || roles.includes(user.role));

  return (
    <AuthCtx.Provider value={{ user, token, login, logout, hasRole }}>
      {children}
    </AuthCtx.Provider>
  );
}
